export const YOUR_TEAM = 'your team';
